import { HttpErrorResponse } from '@angular/common/http';
import { NO_LICENSES_AVAILABLE_ERROR_DETAIL } from '@common/constants';

export function isNoLicensesAvailable(error: HttpErrorResponse): boolean {
  const errorDetails = error?.error?.value || '';

  return errorDetails?.replace(/\s+/g, '').toLowerCase() === NO_LICENSES_AVAILABLE_ERROR_DETAIL.toLowerCase();
}
